import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import Events from '../hooks/events';

const DatasetConvertDataAction = ({
  category,
  code,
  name,
  disabled,
}) => {
  const convert = Events.useConvertDatasetData(category, { code });

  return (
    <RibbonMenu
      name="convert"
      icon="arrow alternate circle right"
      message="actions.convert"
      className="aridhia-dataset-convert-action"
      onClick={() => convert(category, code, name)}
      disabled={disabled}
    />
  );
};

export default DatasetConvertDataAction;
